import { ref } from 'vue'

export type ToastVariant = 'success' | 'error' | 'info'

export interface ToastEntry {
  id: string
  message: string
  variant: ToastVariant
}

// Module-level (not per-component) so every call site shares the same
// queue — NotificationStack.vue (mounted once in App.vue) is the only thing
// that renders it, but any component can push to it via notify().
const toasts = ref<ToastEntry[]>([])
const DEFAULT_DURATION_MS = 4000

function dismiss(id: string) {
  toasts.value = toasts.value.filter((t) => t.id !== id)
}

function notify(message: string, variant: ToastVariant = 'info', durationMs = DEFAULT_DURATION_MS) {
  const id = crypto.randomUUID()
  toasts.value = [...toasts.value, { id, message, variant }]
  if (durationMs > 0) {
    window.setTimeout(() => dismiss(id), durationMs)
  }
  return id
}

export function useToast() {
  return {
    toasts,
    notify,
    dismiss,
    success: (message: string, durationMs?: number) => notify(message, 'success', durationMs),
    error: (message: string, durationMs?: number) => notify(message, 'error', durationMs),
    info: (message: string, durationMs?: number) => notify(message, 'info', durationMs),
  }
}
